export const SET_MENU = 'SET_MENU';
